import styled from 'styled-components/native';

export default styled.ScrollView.attrs({ nestedScrollEnabled: true })`
  height: 0;
  margin: 25px 0 0;
`;
